import { Spinner } from './spinner'

/** Router defaultPendingComponent — centers a spinner in the content area
 *  while a route loader is in flight. The surrounding ClientShell (sidebar +
 *  topbar) stays mounted, so only this content region shows the spinner. */
export function RoutePending() {
  return (
    <div
      className="flex flex-col items-center justify-center gap-3"
      style={{ minHeight: '50vh' }}
    >
      <Spinner size={32} />
      <span className="scc-muted text-sm">Loading…</span>
    </div>
  )
}
